import { useMarketAnalysisHeroContent } from '../../../../hooks/useMarketAnalysisHeroContent';
import './Hero.css';

const Hero = () => {
  const { content, isLoading } = useMarketAnalysisHeroContent();

  if (isLoading || !content) {
    return null;
  }

  const { eyebrow, title, text } = content;

  return (
    <section className="market-analysis-hero">
      <div className="market-analysis-hero__inner">
        {eyebrow ? <p className="market-analysis-hero__eyebrow">{eyebrow}</p> : null}
        <h1 className="market-analysis-hero__title">{title}</h1>
        {text ? <p className="market-analysis-hero__text">{text}</p> : null}
      </div>
    </section>
  );
};

export default Hero;
